import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Image, TextField } from '@iho-design-system/Loader';

/*
    - icons
*/
import SendSVG from '../../assets/images/help-desk/send.svg';

const SearchInput = ({ reservesResult, searchInputPlaceholder, searchInputSearchKeyProps, toggleTabProps }) => {

    /*
        - defaultData
    */
    const [searchKey, setSearchKey] = React.useState('');
    const [readonlyStatus, setReadonlyStatus] = React.useState(true);

    /*
        - handleSearchKey
    */
    const handleSearchKey = (searchKey) => {
        setSearchKey(toEnglishDigit(searchKey));
        searchInputSearchKeyProps(toEnglishDigit(searchKey));
    }

    /*
        - toEnglishDigit
    */
    const toEnglishDigit = (string) => {
        return string.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
            return c.charCodeAt(0) & 0xf;
        });
    }

    React.useEffect(() => {
        if (searchInputPlaceholder !== '') {
            setReadonlyStatus(false);
        } else {
            setReadonlyStatus(true);
        }
    }, [searchInputPlaceholder])

    return (

        <React.Fragment>
            
            {reservesResult !== 'empty' &&
                <Box
                    className={`my-sm mb-0 position-relative`}>
                    <TextField
                        onChange={handleSearchKey}
                        variant='filled'
                        placeholder={searchInputPlaceholder}
                        value={searchKey}
                        readonly={readonlyStatus} />
                    <Box
                        className={`p-sm rounded-sm pointer position-absolute top-xs left-sm`}
                        ms={{
                            backgroundColor: 'var(--blue-light)'
                        }}>
                        <Image
                            src={SendSVG}
                            alt='send'
                            ms={{
                                width: '16px',
                                height: '16px'
                            }} />
                    </Box>
                </Box>
            }
            {reservesResult === 'empty' &&
                <Button
                    onClick={() => toggleTabProps('home')}
                    className={`w-100`}
                    variant='filled'
                    color='primary'>
                    بازگشت به منوی اصلی
                </Button>
            }

        </React.Fragment>

    );

}

export default SearchInput;